import React from 'react';
import useImagePreload from '../../hooks/useImagePreload';
import BrandedLoader from '../BrandedLoader/BrandedLoader';
import './PageBanner.css';

/**
 * Shared banner for every non-Home page.
 *
 * This exists for three reasons at once: it gives each page an
 * "appropriate picture" the way a high-end site would, it guarantees
 * a dark region sits directly behind the fixed nav at scroll position
 * 0 -- which is what keeps the nav's white text legible on pages that
 * would otherwise open on a plain white background -- and it holds
 * off the zoom-in animation (and the banner itself) until its image
 * has actually finished loading, so the effect doesn't run against a
 * still-downloading image on a cold cache. If `image` is omitted, a
 * plain navy gradient is used instead and nothing needs
 * to be preloaded.
 */
export default function PageBanner({ image, eyebrow, title, subtitle, height = 'md' }) {
  const ready = useImagePreload(image);

  if (image && !ready) {
    return (
      <header className={`page-banner page-banner--${height}`}>
        <BrandedLoader />
      </header>
    );
  }

  return (
    <header className={`page-banner page-banner--${height} ${image ? '' : 'page-banner--plain'}`}>
      {image && (
        <div className="page-banner__media">
          <img src={image} alt="" />
          <div className="page-banner__scrim" aria-hidden="true" />
        </div>
      )}
      <div className="container page-banner__content">
        {eyebrow && <p className="page-banner__eyebrow">{eyebrow}</p>}
        <h1 className="page-banner__title">{title}</h1>
        {subtitle && <p className="page-banner__subtitle">{subtitle}</p>}
      </div>
    </header>
  );
}
